import { render } from "./edit.vue?vue&type=template&id=a1f56bbe&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=a1f56bbe&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f56bbe"],['__file',"src/views/settings/printer/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a1f56bbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a1f56bbe', __exports__)) {
    console.log('reload')
    api.reload('a1f56bbe', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=a1f56bbe&scoped=true", () => {
    console.log('re-render')
    api.rerender('a1f56bbe', render)
  })

}


export default __exports__